import { Icon } from "@iconify/react";
import { useRef, useState } from "react";
import styled from "styled-components";
import { AppSettings } from "../../../assets/store/app.settings";
import { Theme } from "../../themes/theme";

const LangContainer = styled.div`
  position: relative;
  display: inline-block;
`;

const LangTrigger = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 500;
  color: ${Theme.color.text.neutral};
  transition: all 0.2s ease;

  &:hover {
    color: ${Theme.color.text.primary};
    background-color: rgba(0, 0, 0, 0.03);
  }

  .chevron {
    transition: transform 0.2s ease;
    transform: ${(props) => (props.$isOpen ? "rotate(180deg)" : "rotate(0)")};
  }
`;

const LangDropdown = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: white;
  min-width: 130px;
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.06);
  padding: 6px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  z-index: 110;

  animation: slideDown 0.2s ease forwards;
  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const DropdownItem = styled.button`
  background: none;
  border: none;
  text-align: left;
  padding: 8px 12px;
  font-size: 0.88rem;
  font-weight: ${(props) => (props.$isActive ? "600" : "400")};
  color: ${(props) =>
    props.$isActive ? Theme.color.text.primary : Theme.color.text.neutral};
  background-color: ${(props) =>
    props.$isActive ? "rgba(0, 0, 0, 0.02)" : "transparent"};
  border-radius: 6px;
  cursor: pointer;
  width: 100%;
  transition: all 0.15s ease;

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
    color: ${Theme.color.text.primary};
  }
`;

const LANGUAGES = AppSettings.supportedLanguages;
function LanguageDropdown() {
  const dropdownRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [currentLang, setCurrentLang] = useState(LANGUAGES.english);
  return (
    <LangContainer ref={dropdownRef}>
      <LangTrigger $isOpen={isOpen} onClick={() => setIsOpen(!isOpen)}>
        <Icon icon="lucide:globe" width="18" height="18" />
        <span>{currentLang}</span>
        <Icon
          icon="lucide:chevron-down"
          width="14"
          height="14"
          className="chevron"
        />
      </LangTrigger>

      {isOpen && (
        <LangDropdown>
          {Object.keys(AppSettings.supportedLanguages).map((lang, key) => (
            <DropdownItem
              key={key}
              $isActive={currentLang === LANGUAGES[lang]}
              onClick={() => {
                setCurrentLang(LANGUAGES[lang]);
                setIsOpen(false);
              }}
            >
              {AppSettings.supportedLanguages[lang]}
            </DropdownItem>
          ))}
        </LangDropdown>
      )}
    </LangContainer>
  );
}

export default LanguageDropdown;
